var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#067BC2",
    fillRule: "evenodd",
    d: "M16.2 8.1V0h-1.8v8.1h-1.8v1.8h1.8V18h1.8V9.9H18V8.1h-1.8zM9.9 0H8.1v3.6H6.3v1.8h1.8V18h1.8V5.4h1.8V3.6H9.9V0zM3.6 8.1h1.8v1.8H3.6V18H1.8V9.9H0V8.1h1.8V0h1.8v8.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.09add888b10335fd3a3df30011b93b44.svg";
export { ForwardRef as ReactComponent };